import React from 'react';
import { Link } from 'gatsby';
import { kebabCase } from 'lodash';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';

import Image from 'src/components/common/Image';

import styles from './DevPostInfo.module.scss';

const cx = classNames.bind(styles);

const DevPostInfo = ({ title, date, image, tags }) => {
  const tagList = tags.map(tag => (
    <Link key={kebabCase(tag)} to={`/tags/${kebabCase(tag)}/`}>
      #{tag}
    </Link>
  ));

  return (
    <div className={cx('page-info')}>
      <div className={cx('inner-wrap')}>
        <div className={cx('date')}>{date}</div>
        <h1>{title}</h1>
        <div className={cx('tags')}>{tagList}</div>
      </div>
      <div className={cx('image')}>
        <Image image={image} style={{ width: '100%' }} />
      </div>
    </div>
  );
};

DevPostInfo.propTypes = {
  title: PropTypes.string.isRequired,
  date: PropTypes.string,
  image: PropTypes.object,
  tags: PropTypes.array,
};

export default DevPostInfo;
